import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { Shift, CreateShiftRequest, UpdateShiftRequest } from '../interfaces/shift/Shift';

export const ShiftService = {
    list: async (institutionId: string): Promise<Shift[]> => {
        const response = await axios.get(ENDPOINTS.SHIFT.BY_INSTITUTION(institutionId));
        return response.data;
    },
    getById: async (institutionId: string, id: string): Promise<Shift> => {
        const response = await axios.get(ENDPOINTS.SHIFT.BY_ID(institutionId, id));
        return response.data;
    },
    create: async (institutionId: string, body: CreateShiftRequest): Promise<Shift> => {
        const response = await axios.post(ENDPOINTS.SHIFT.BY_INSTITUTION(institutionId), body);
        return response.data;
    },
    update: async (institutionId: string, id: string, body: UpdateShiftRequest): Promise<Shift> => {
        const response = await axios.put(ENDPOINTS.SHIFT.BY_ID(institutionId, id), body);
        return response.data;
    },
    remove: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.SHIFT.BY_ID(institutionId, id));
    },
};
